module.exports = __webpack_public_path__ + "media/images/Sign-up_Welcome-8977e1f6.png";